import { toast } from 'react-toastify';
import { processQRCodeImage, sendQRCodeValue } from '../services/qrCodeService';

/**
 * Hook for managing QR code scanning workflow
 */
const useQRScanning = () => {
    const handleQRCodeUpload = async (imageFile, setIsUploading, setPreviewImage, resetCamera) => {
        setIsUploading(true);
        const imageUrl = URL.createObjectURL(imageFile);

        try {
            // Show preview
            setPreviewImage(imageUrl);

            // Process QR code
            const qrData = await processQRCodeImage(imageFile);

            if (qrData) {
                console.log('Found QR code:', qrData);
                toast.success(`QR code found: ${qrData}`);

                // Try to send to backend, but don't fail if it's not configured
                try {
                    await sendQRCodeValue(qrData);
                    console.log('QR code sent to backend successfully');
                } catch (error) {
                    console.warn('Failed to send QR code to backend (this is optional):', error.message);
                    // Don't show error toast for backend issues - QR detection was successful
                }

                resetCamera();
            } else {
                toast.error('No QR code found in image');
                resetCamera();
            }
        } catch (error) {
            console.error('Error processing QR code:', error);
            toast.error('Failed to process QR code. Please try again.');
            resetCamera();
        } finally {
            setIsUploading(false);
        }
    };

    return {
        handleQRCodeUpload
    };
};

export default useQRScanning;
